export default function buildOnlineCircleConfig(legendData, data, name) {
  return {
    title: {
      text: name,
      textStyle: {
        color: '#fff',
        fontSize: 14
      },
      bottom: 0,
      left: 'center'
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 15,
      textStyle: {
        color: 'white',
        fontSize: 16,
        fontWeight: 'bold'
      },
      data: legendData
    },
    color: ['#7FD7FF', 'rgba(18, 197, 192, 0.01)'],
    series: [
      {
        name: name,
        type: 'pie',
        radius: ['55%', '74%'],
        center: ["50%", "45%"],
        avoidLabelOverlap: false,
        // label: {
        //   normal: {
        //     show: true,
        //     position: 'center',
        //     fontSize: '24',
        //     fontWeight: 'bold',
        //     color: '#7FD7FF',
        //     formatter: function(params) {
        //       if(params.name === '在线') {
        //         return params.percent + '%'
        //       }
        //       return ''
        //     }
        //   }
        // },
        label: {
          show: true,
          position: 'center',
          fontSize: 24,
          color: '#7FD7FF',
          formatter: function(param) {
            return (param.percent).toFixed(1) + '%'
          }
        },
        // emphasis: {
        //   label: {
        //     show: true,
        //     fontSize: '30',
        //     fontWeight: 'bold'
        //   }
        // },
        labelLine: {
          show: false
        },
        data: data
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/config/chart/config_online_circle.js